export default "__VITE_ASSET__Djl0pkx3__"